import { Button } from "@/components/ui/button";

interface SlackConnectionActionProps {
  isOwner: boolean;
  hasInstallation: boolean;
  isInstallPending: boolean;
  onAddToSlack: () => void;
  onDisconnect: () => void;
}

export const SlackConnectionAction = ({
  isOwner,
  hasInstallation,
  isInstallPending,
  onAddToSlack,
  onDisconnect,
}: SlackConnectionActionProps) => {
  if (!isOwner) {
    return (
      <p className="text-sm text-gray-500">
        Only the organization owner can {hasInstallation ? "disconnect" : "connect"} Slack.
      </p>
    );
  }
  if (hasInstallation) {
    return (
      <Button variant="destructiveOutline" onClick={onDisconnect}>
        Disconnect
      </Button>
    );
  }
  return (
    <Button onClick={onAddToSlack} disabled={isInstallPending}>
      Add to Slack
    </Button>
  );
};
